<script setup lang="ts">
import type { PortableTextMarkComponentProps } from "@portabletext/vue";
import type { DOCUMENT } from "@pkg/config/sanity/schemas";
import type { LOCALE_CODE } from "@pkg/config/languages/localeCodes";
import CustomLink from "@pkg/link/src/components/CustomLink.vue";
import { type LinkType } from "@pkg/link";

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<
  PortableTextMarkComponentProps<{
    // Keys come in under props.value
    _key: string;
    _type: string;
    link?: {
      _type: DOCUMENT;
      slug: string;
      locale: LOCALE_CODE;
    };
    reference?: {
      _type: DOCUMENT.PAGES;
      slug: string;
      locale: LOCALE_CODE;
    };
    newWindow: boolean;
    internalAnchor?: string;
    ctaStyle?: boolean;
  }>
>();
</script>

<template>
  <CustomLink v-if="props.value?.link" :link="(props.value.link as LinkType)" :newWindow="props.value.newWindow" class="cta">
    <slot />
  </CustomLink>
  <CustomLink v-if="props.value?.reference" :link="props.value?.reference" :anchor="props.value.internalAnchor" :newWindow="props.value.newWindow" >
    <UiButton v-if="props.value?.ctaStyle">
      <slot />
    </UiButton>
    <slot v-else />
  </CustomLink>
</template>
